import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import { useTranslation } from 'react-i18next'; // Optional

const MyListingsPage = () => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  
  useEffect(() => {
    fetchListings();
  }, []);

  const fetchListings = async () => {
    try {
      const res = await api.get('/map/my-listings');
      setListings(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if(!window.confirm(t('profile.alerts.confirm-delete-listing'))) return;
    try {
      await api.delete(`/map/listing/${id}`);
      setListings(listings.filter(l => l._id !== id)); // Remove from UI
    } catch (err) {
      alert(t('profile.alerts.error-deleting-listing'));
    }
  };

  const normalizeKey = (str) => {
    if (!str) return '';
    return str.toString().toLowerCase().trim().replace(/\s+/g, '-');
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900"> {t('map.services')} </h1>
        <Link 
          to="/provider/edit-listing" // Takes you to a blank form
          className="bg-[#1d5cab] hover:bg-[#2372bd] text-white px-4 py-2 rounded-lg font-bold transition"
        >
          {t('map.add-service')}
        </Link>
      </div>

      {loading ? (
        <p>{t('general.loading')}</p>
      ) : listings.length === 0 ? (
        <div className="text-center py-10 bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl">
            <p className="text-gray-500 mb-4">{t('profile.alerts.no-active-listings')}</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {listings.map(item => {
            const statusKey = normalizeKey(item.contractStatus); // e.g. "active", "pending", "expired"
            const tierKey = normalizeKey(item.tier); // e.g. "premium", "basic", "silver"
            
            return(
            
            <div key={item._id} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex justify-between items-center">
                <div>
                    <h3 className="font-bold text-xl">{item.businessName}</h3>
                    <div className="flex gap-2 text-sm mt-1">
                        <span className={`px-2 py-0.5 rounded text-xs font-bold ${
                            item.contractStatus === 'Active' ? 'bg-green-100 text-green-700' : 
                            item.contractStatus === 'Pending' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'
                        }`}>
                            {t(`map.${statusKey}`, { defaultValue: item.contractStatus })}
                        </span>
                        <span className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded text-xs">
                            {t(`map.${tierKey}`, { defaultValue: item.tier })}
                        </span>
                    </div>
                </div>
                
                <div className="flex gap-3">
                    {/* EDIT Button - Passes the ID via URL */}
                    <Link 
                        to={`/provider/edit-listing/${item._id}`}
                        className="text-blue-600 font-medium hover:underline"
                    >
                        {t('general.edit')}
                    </Link>
                    
                    {/* CANCEL Button */}
                    <button 
                        onClick={() => handleDelete(item._id)}
                        className="text-red-500 font-medium hover:text-red-700"
                    >
                        {t('general.cancel')}
                    </button>
                </div>
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyListingsPage;
